import './app.scss';

import startPreload from './preload';
import { initLazyLoading } from './js/lazyloading';
import { initShareButtons } from './js/share';
import { InitScrollBars } from './js/scrollbars';
import { initViewPortHeightVar } from './js/utils/viewportHeightVar';
import AppMVC from './js/app/appMVC';

window.projectScriptsConnected = true;

initLazyLoading();
initShareButtons();
InitScrollBars();
initViewPortHeightVar();
// initOnClickAnalytics();

// eslint-disable-next-line
const appMVC = new AppMVC();

startPreload();
